import { transformFootnote } from "../transformFootnote";

const getBaseUri = () => {
  let baseURI = document.baseURI;
  if (baseURI !== undefined && baseURI !== null) {
    const baseTags = document.getElementsByTagName("base");
    baseURI = baseTags.length > 0 ? baseTags[0].href : document.URL;
  }
  return baseURI;
};

const fixImgixImages = (element: Element) => {
  element.querySelectorAll("[data-aoe-imgix]").forEach(fixImageSourcePath);
  return element;
};

const fixImageSourcePath = (image: HTMLImageElement) => {
  const dataSrc = image.getAttribute("data-src");
  const regex = /^(http|\/)/;
  if (!regex.test(dataSrc)) {
    image.setAttribute("data-src", new URL(getBaseUri() + dataSrc).pathname);
  }
  return image;
};

const fixFootnotes = (element: Element) => {
  element.querySelectorAll("footnote").forEach(transformFootnote);
  return element;
};

export const createElementFromHtmlContent = (
  content: string,
): Element | null => {
  const div = document.createElement("div");
  div.innerHTML = content.trim();
  let element = div.firstElementChild;
  if (element !== null) {
    element = fixImgixImages(element);
    element = fixFootnotes(element);
  }
  return element;
};
